import React from 'react';

import { Block, RecursiveMenu } from '@uncinc/react-drupal-core';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import SocialMenu from '../Social';
import Sponsors from '../Sponsors';
import Logo from '../Logo';

import { APP_OPTIONS } from '../../../config/constants';

import './style.scss';

const FooterMenu = () => {
  const { copyRight } = APP_OPTIONS.parameters;

  return (
    <div className="FooterMenu">
      <Container>
        <div className="row FooterMenu__top-section">
          <div className="col-12">
            <Logo />
          </div>
        </div>
      </Container>
      <div className="FooterMenu__main-section">
        <Container>
          <div className="row">
            <div className="col-12 col-lg-9">
              <div className="FooterMenu__main-section__footer-menu">
                <RecursiveMenu menuId="footer" maxLevel={2} />
              </div>
            </div>
            <div className="col-12 col-lg-3">
              <div className="FooterMenu__main-section__contact-block">
                <Block id={APP_OPTIONS.parameters.contactBlockID} />
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="FooterMenu__bottom-section">
        <Container>
          <div className="FooterMenu__bottom-section__wrapper">
            <div className="FooterMenu__bottom-section__social">
              <SocialMenu />
            </div>
            <div className="FooterMenu__bottom-section__sponsors">
              <Sponsors />
            </div>
            <div className="FooterMenu__bottom-section__legal">
              <RecursiveMenu
                menuId="legal"
                maxLevel={1}
              />
            </div>
            <div className="FooterMenu__bottom-section__copyright">
              &copy;&nbsp;{copyRight}&nbsp;{new Date().getUTCFullYear()}
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};


export default FooterMenu;
